import { ModifierDictionary } from '../../../../services/commands/constants';

export const getShortCutCombinationStrings = (
  e: KeyboardEvent
): Record<'codeCombinationString' | 'keyCombinationString', string> => {
  const filter = (
    prop: keyof KeyboardEvent & ('code' | 'key') = 'code'
  ): string =>
    [
      ...Object.entries(ModifierDictionary).map(
        ([name, value]) =>
          e[name as keyof typeof ModifierDictionary] &&
          (value === ModifierDictionary.metaKey
            ? ModifierDictionary.ctrlKey
            : value)
      ),
      prop === 'code' ? e[prop].replace(/^Key/, '') : e[prop],
    ]
      .filter(Boolean)
      .join('+');
  return {
    codeCombinationString: filter(),
    keyCombinationString: filter('key'),
  };
};
